import type { Enums } from "@msuite/utils/types";
import { enumeration, string, table } from "@rocicorp/zero";
import { coreFields } from "./shared";

export const workspace = table("workspaces")
	.columns({
		...coreFields,
		orgId: string().from("org_id"),
		name: string(),
		color: enumeration<Enums<"color">>(),
	})
	.primaryKey("id");
